import { useEffect } from "react";

const useScrollTop = dependency => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [dependency]);
};

export default useScrollTop;
